import React from 'react';
import PropTypes from 'prop-types';
import {useNavigate, useParams} from 'react-router-dom';
import {CircularProgress, Stack} from '@mui/material';
import useFileDownloader from '../../../utility/hooks/useFileDownloader';
import {downloadFormRequestAttachment} from '../../../api/services/filesService';
import useUser from '../../../utility/hooks/useUser';
import FormRequest from
        '../../SchoolDashboard/RequestAndResponses/components/FormRequest';
import {useGetFormRequestQuery, useGetEmployeeNotificationFormRequestQuery} from
        '../../../api/services/formRequestsService';

const ApprovalFormRequest = ({navigateBackRoute}) => {
    const {user} = useUser();
    const downloadFile = useFileDownloader();
    const navigate = useNavigate();
    let {employeeId, formRequestId, formId} = useParams();

    const {
        data: formRequest,
        isLoading,
        isFetching,
        error,
    } = useGetFormRequestQuery(formRequestId, {skip: !formRequestId});

    const {data: employeeData} = useGetEmployeeNotificationFormRequestQuery(
        {formId, personId: employeeId},
        {skip: !formId || !employeeId}
    );

    const handleDownloadAttachment = async (fileId) => {
        await downloadFile(downloadFormRequestAttachment, {
            fileId,
            formRequestId,
            roles: user.roles,
            studentId: formRequest?.studentId,
            shouldDownloadByCurrentUser: false
        });
    };

    if (isLoading || isFetching) {
        return (
            <Stack alignItems="center" mt={4}>
                <CircularProgress/>
            </Stack>
        );
    }

    if (error?.status === 403 || error?.status === 404 || !formRequest) {
        navigate(navigateBackRoute, {replace: true});
        return null;
    }

    return (
        <FormRequest
            formRequest={formRequest || employeeData}
            isLoading={false}
            error={null}
            navigateBackRoute={navigateBackRoute}
            onDownloadAttachment={handleDownloadAttachment}
        />
    );
};

ApprovalFormRequest.propTypes = {
    navigateBackRoute: PropTypes.string.isRequired,
};

export default ApprovalFormRequest;
